module.exports = {
    text: "#FFF",
}